import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const DeleteConfirmationModal = ({ isOpen, toggle, itemsToDelete, onConfirm, displayKey }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Kayıtları Sil</ModalHeader>
            <ModalBody>
                Seçilen kayıtları silmek istediğinizden emin misiniz?
                <ul>
                    {itemsToDelete.map((item) => (
                        <li key={item.id}>
                            {item[displayKey] || item.id || 'Bilinmeyen Kayıt'}
                        </li>
                    ))}
                </ul>
            </ModalBody>
            <ModalFooter>
                <div className='btn btn-outline-danger ms-2 rounded-pill' onClick={onConfirm}>
                    {'Sil'}
                </div>
                <div className='btn btn-outline-primary ms-2 rounded-pill' onClick={toggle}>
                    {'Vazgeç'}
                </div>
            </ModalFooter>
        </Modal>
    );
};

export default DeleteConfirmationModal;
